import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchBanners = createAsyncThunk(
  "newsBanners/fetchBanners",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/newsBanner"); // Ensure the request is correct

      console.log("Fetched banners (API Response):", data);

      if (!data?.newsBanners || !Array.isArray(data.newsBanners)) {
        return rejectWithValue(
          "Invalid API response format: Expected { newsBanners: [] }"
        );
      }

      return data.newsBanners; // Only return the array
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch banners");
    }
  }
);

const newsBannersSlice = createSlice({
  name: "newsBanners",
  initialState: {
    banners: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBanners.fulfilled, (state, { payload }) => {
        console.log("Final payload stored in Redux:", payload);
        state.status = "succeeded";
        state.banners = payload; // Store only the array
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default newsBannersSlice.reducer;
